import { Loader2 } from 'lucide-react';
import React from 'react';
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import { useDashboardContext } from './DashboardContext';
import { formatMoney, formatTooltipMoney, PAYMENT_COLORS } from './helpers';

export const SpendingOverviewCard: React.FC = () => {
  const { dashboard, loadingStates } = useDashboardContext();
  const data = dashboard.paymentBreakdown.slice(0, 4);
  return (
    <div className="flex flex-col rounded-[22px] border border-slate-100 bg-white p-5 shadow-[0_2px_8px_rgba(0,0,0,0.02)] lg:col-span-1">
      <div className="flex items-center justify-between">
        <h3 className="text-[13px] font-semibold text-slate-900">
          Payment Mix
        </h3>
        <span className="rounded-md bg-slate-50 px-2 py-0.5 text-[10px] text-slate-400">
          This Range
        </span>
      </div>

      {loadingStates.payments ? (
        <div className="mt-3 flex min-h-[130px] flex-1 items-center justify-center">
          <Loader2 className="animate-spin text-slate-300" size={24} />
        </div>
      ) : (
        <>
          <div className="relative mt-3 flex min-h-[130px] flex-1 items-center justify-center">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={data}
                  dataKey="total_amount"
                  nameKey="payment_method_name"
                  innerRadius={42}
                  outerRadius={60}
                  paddingAngle={2}
                >
                  {data.map((entry, index) => (
                    <Cell
                      key={entry.payment_method_name}
                      fill={PAYMENT_COLORS[index % PAYMENT_COLORS.length]}
                    />
                  ))}
                </Pie>
                <Tooltip formatter={(value) => formatTooltipMoney(value)} />
              </PieChart>
            </ResponsiveContainer>
            <div className="pointer-events-none absolute inset-0 flex flex-col items-center justify-center">
              <span className="text-[9px] text-slate-400">Top</span>
              <span className="max-w-[72px] truncate text-[11px] font-bold text-slate-900">
                {data[0]?.payment_method_name || 'N/A'}
              </span>
            </div>
          </div>

          <div className="mt-3 space-y-1.5 min-h-[60px]">
            {data.slice(0, 3).map((item, i) => (
              <div
                key={item.payment_method_name}
                className="flex items-center justify-between text-[11px]"
              >
                <div className="flex items-center gap-1.5">
                  <span
                    className="h-2 w-2 rounded-full"
                    style={{
                      backgroundColor:
                        PAYMENT_COLORS[i % PAYMENT_COLORS.length],
                    }}
                  />
                  <span className="max-w-[80px] truncate text-slate-600">
                    {item.payment_method_name}
                  </span>
                </div>
                <span className="truncate font-semibold text-slate-900">
                  {formatMoney(item.total_amount)}
                </span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};
